const { REACT_APP_SITE_API = "" } = process.env;

// NOTE: this variable is decided based on the global bible api stage
// auth related features can break when local development tries to
// to use it's development auth token against the staging api
// the logic below is designed to pick the same cognito pool/client id/pubnub keys
// that are used by the api
type Stage = "development" | "staging" | "production";

let gbApiStage: Stage;
if (
  REACT_APP_SITE_API.includes("localhost") ||
  REACT_APP_SITE_API.includes("dev")
) {
  gbApiStage = "development";
} else if (REACT_APP_SITE_API.includes("stage")) {
  gbApiStage = "staging";
} else {
  gbApiStage = "production";
}

const config = {
  defaultChapter: "MAT.1",
  featureFlags: {
    translationFeedback:
      process.env.REACT_APP_ENABLE_TRANSLATION_FEEDBACK === "true"
  },
  cognitoConfig: {
    development: {
      aws_project_region: "us-east-1",
      aws_cognito_region: "us-east-1",
      aws_user_pools_id: "us-east-1_N1k5CyYCY",
      aws_user_pools_web_client_id: "5jfnkhn055d961opqiih9attge"
    },
    staging: {
      aws_project_region: "us-east-1",
      aws_cognito_region: "us-east-1",
      aws_user_pools_id: "us-east-1_juCxhDZ7Z",
      aws_user_pools_web_client_id: "2kl29qvb3mb2onulododg7ve8e"
    },
    production: {
      aws_project_region: "us-east-1",
      aws_cognito_region: "us-east-1",
      aws_user_pools_id: "us-east-1_KpWRJ5Y1B",
      aws_user_pools_web_client_id: "6c7bvte6j78lk5kpirkrb7ho0e"
    }
  }[gbApiStage],
  pubNubKeys: {
    development: {
      publishKey: "pub-c-01059ba7-d403-4dc7-b970-89d7dd9fdfb6",
      subscribeKey: "sub-c-f66c70dc-21ab-11ea-9c02-4a7cb839a01e"
    },
    staging: {
      publishKey: "pub-c-27de306b-eecf-44d7-9a42-1348a2ef9f97",
      subscribeKey: "sub-c-3ac46874-58c6-11ea-b451-9a833ea0503a"
    },
    production: {
      publishKey: "pub-c-7ad7412b-1d26-468d-bea5-bae9c8b2ed64",
      subscribeKey: "sub-c-8d407e96-5725-11ea-bf00-e20787371c02"
    }
  }[gbApiStage]
};

export default config;
